/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { TeamMemberDtoModel, TeamMemberDtoModelType } from "./TeamMemberDtoModel"
import { TeamMemberDtoModelSelector } from "./TeamMemberDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  member: TeamMemberDtoModelType;
}

/**
 * TeamMemberUpdatedDtoBase
 * auto generated base class for the model TeamMemberUpdatedDtoModel.
 */
export const TeamMemberUpdatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('TeamMemberUpdatedDto')
  .props({
    __typename: types.optional(types.literal("TeamMemberUpdatedDto"), "TeamMemberUpdatedDto"),
    /** Team member updated */
    member: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => TeamMemberDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class TeamMemberUpdatedDtoModelSelector extends QueryBuilder {
  member(builder: string | TeamMemberDtoModelSelector | ((selector: TeamMemberDtoModelSelector) => TeamMemberDtoModelSelector) | undefined) { return this.__child(`member`, TeamMemberDtoModelSelector, builder) }
}
export function selectFromTeamMemberUpdatedDto() {
  return new TeamMemberUpdatedDtoModelSelector()
}

export const teamMemberUpdatedDtoModelPrimitives = selectFromTeamMemberUpdatedDto()
